import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import PopUp from "../PopUp";
import api from "../api/api";
import List from "../List";
import InvoiceFormPopup from "./InvoiceFormPopup";
import SearchIcon from "../../icons/SearchIcon";

function InvoicePopup() {
	const {
		cart,
		setInvoiceFormPopup,
		setLoading,
		setConfirm,
		setInvoicePopup,
		init_cart,
		updateOrder,
		invoiceFormPopup,
		checkout,
		setPosPaymentPopup,
		editCart2,
		total,
	} = useContext(AppContext);
	const [searchTerm, setSearchTerm] = useState("");
	const [addresses, setAddresses] = useState([]);
	const [customers, setCustomers] = useState([]);
	const [searchExecuted, setSearchExecuted] = useState(false);

	const clearSearch = () => {
		setSearchTerm("");
		setCustomers([]);
		if (!cart.customer) setAddresses([]);
		setSearchExecuted(false);
	};

	useEffect(() => {
		refreshAddress();
	}, [cart.customer, invoiceFormPopup]);

	useEffect(() => {
		const delayDebounceFn = setTimeout(async () => {
			if (!searchTerm) {
				setCustomers([]);
				if (!cart.customer) setAddresses([]);
				setSearchExecuted(false);
				return;
			}
			if (cart.customer) {
				setCustomers([]);
				setSearchExecuted(false);
				return;
			}
			const res1 = await api.postProtected("/customers/list/", {
				src: [
					{
						name: "global",
						value: searchTerm,
						compare: "id,name,surname,email,mobile",
					},
					{ name: "blacklist", value: 0, compare: "equal" },
				],
			});
			setCustomers(res1.rows);
			const res2 = await api.postProtected("/addresses_billing/list/", {
				src: [
					{
						name: "global",
						value: searchTerm,
						compare: "id,company,address,city,province,vat,taxcode,sdi,pec",
					},
				],
			});
			if (res2.success == 0) alert(res2.error);
			else setAddresses(res2.rows);
			setSearchExecuted(true);
		}, 1000);

		return () => clearTimeout(delayDebounceFn);
	}, [searchTerm, cart.customer]);

	const refreshAddress = async () => {
		if (cart.customer) {
			setLoading(true);
			const res = await api.postProtected("/addresses_billing/list/", {
				src: [{ name: "customer_id", value: cart.customer.id, compare: "equal" }],
			});
			setLoading(false);
			if (res.success == 1) {
				setAddresses(res.rows);
			} else
				setConfirm({
					title: "Errore",
					message: res.error,
				});
		}
	};

	const isEditing = () => {
		//console.log("isEditing", cart);
		let res = false;
		if (cart.order_id) res = true;
		//console.log("isEditing", res);
		return res;
	};

	const getCustomerById = async (customerId) => {
		const res = await api.postProtected("/customers/get/" + customerId + "/");
		if (res.success == 0) {
			setLoading(false);
			setConfirm({
				title: "Errore",
				message: res.error,
			});
		} else return res.data;
	};

	return (
		<>
			<PopUp
				size=""
				customClass="invoice-popup"
				options={{
					onClose: () => setInvoicePopup(false),
					title: "Fattura",
				}}
			>
				<div className="inner-content invoice-popup-content">
					{cart.customer && (
						<div className="invoice-selected-customer-section">
							<h3>Cliente selezionato</h3>
							<div className="input-group invoice-selected-customer-card">
								<div className="invoice-selected-customer-info">
									<div className="invoice-selected-customer-name">
										{cart.customer.surname + " " + cart.customer.name}
									</div>
									<div className="invoice-selected-customer-email">
										{cart.customer.email}
									</div>
								</div>
								<div className="invoice-selected-customer-actions">
									<button
										onClick={() => {
											setCustomers([]);
											setAddresses([]);
											editCart2({
												customer: false,
											});
										}}
									>
										Cambia
									</button>
									<button onClick={() => setInvoiceFormPopup(true)}>
										Aggiungi ragione sociale
									</button>
								</div>
							</div>
						</div>
					)}
					{!cart.customer && (
						<>
							<div className="customer-flow-options invoice-popup-options">
								<div className="customer-flow-option-card">
									<div className="customer-flow-option-title customer-flow-option-title-center">
										Cerca azienda/cliente
									</div>
									<div className="customer-flow-search-card">
										<div className="customer-flow-search-fields">
											<div className="customer-flow-search-input-wrap">
												<input
													type="text"
													placeholder="Ricerca"
													autoFocus
													value={searchTerm}
													onChange={(e) => setSearchTerm(e.target.value)}
												/>
												<div className="customer-flow-search-actions">
													{searchTerm ? (
														<button
															type="button"
															className="customer-flow-search-clear"
															onClick={clearSearch}
															aria-label="Pulisci ricerca"
														>
															&times;
														</button>
													) : null}
													<span
														className="customer-flow-search-icon"
														aria-hidden="true"
													>
														<SearchIcon />
													</span>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="customer-flow-option-card">
									<div className="customer-flow-option-title customer-flow-option-title-center">
										Inserisci cliente
									</div>
									<button
										className="button button-2 customer-flow-create-btn"
										onClick={() => setInvoiceFormPopup(true)}
									>
										Crea nuovo cliente
									</button>
								</div>
							</div>
								{customers.length > 0 && (
									<div className="invoice-results-section">
										<div className="invoice-section-title customer-flow-results-title">
											Risultati della ricerca
										</div>
										<div className="customer-flow-results invoice-search-results">
											<List
												elements={customers}
												customElement={(c, i) => (
													<div
														key={i}
														className="list-element group customer-flow-item invoice-search-result-item"
													>
														<div className="client-info">
															<div className="client-name">
																{c.surname + " " + c.name}
															</div>
															<div className="small">
																{c.area_code + c.mobile + " - " + c.email}
															</div>
														</div>
														<div className="buttons">
														<button
															onClick={() => {
																editCart2({
																	customer: c,
																});
																setSearchTerm("");
																setSearchExecuted(false);
																setCustomers([]);
															}}
														>
																Seleziona
															</button>
														</div>
													</div>
												)}
											/>
										</div>
									</div>
								)}
						</>
					)}
					{(cart.customer || searchExecuted) && (
						<div className="invoice-results-section">
							<h3 className="invoice-section-title">Indirizzo di fatturazione</h3>
							{addresses.length > 0 ? (
								<div className="customer-flow-results invoice-address-results">
									<List
										elements={addresses}
										customElement={(c, i) => (
											<div
												key={i}
												className="list-element group customer-flow-address-item invoice-search-result-item"
											>
												<div>
													{c.company}
													<div className="small">{"P.iva " + c.vat}</div>
													<div className="small">{"Sdi " + c.sdi}</div>
													<div className="small">{"C.F. " + c.taxcode}</div>
													<div className="small">{"Pec " + c.pec}</div>
													<div className="small">
														{c.address + " " + c.number}
													</div>
													<div className="small">
														{c.zipcode + " " + c.city + " (" + c.province + ")"}
													</div>
												</div>
												<div className="buttons">
													<button
														className="list-edit-button"
														onClick={() => {
															setInvoiceFormPopup(c);
														}}
													>
														Modifica
													</button>
													<button
														onClick={async () => {
													if (isEditing())
														setConfirm({
															title: "Sei sicuro?",
															message:
																"Procedendo l'ordine non sarà più modificabile",
															onConfirm: async () => {
																setInvoicePopup(false);
																let customerData = cart.customer;
																if (!customerData) {
																	customerData =
																		await getCustomerById(
																			c.customer_id
																		);
																}
																let request = {
																	invoice: 1,
																	billing_address: c,
																	//prebill_request: 1,
																	//prebill_printed: 0,
																	bill: 4,
																	payment_method_id: 4,
																	customer_id: customerData.id,
																	name: customerData.name,
																	surname: customerData.surname,
																	email: customerData.email,
																	mobile: customerData.mobile,
																	payments: cart.payments || [],
																	total: total,
																};
																if (
																	cart.payments.find(
																		(p) =>
																			p.payment_method_id ==
																				14 ||
																			p.payment_method_id ==
																				23
																	)
																) {
																	request.status =
																		"awaiting_payment";
																}
																const res = await updateOrder(
																	{
																		id: cart.order_id,
																	},
																	request
																);
																if (
																	cart.payments.find(
																		(p) =>
																			p.payment_method_id ==
																				14 ||
																			p.payment_method_id ==
																				23
																	)
																) {
																	setPosPaymentPopup({
																		data: res,
																		edit: true,
																	});
																} else {
																	init_cart();
																}
															},
														});
													else {
														checkout(
															false,
															false,
															false,
															false,
															false,
															{
																bill: 4,
																payment_method_id: 4,
																invoice: 1,
																billing_address: c,
																billing_address_id: c.id,
																//prebill_request: 1,
																//prebill_printed: 0,
																customer:
																	cart.customer ||
																	(await getCustomerById(
																		c.customer_id
																	)),
															}
														);
														setInvoicePopup(false);
													}
												}}
													>
														Emetti fattura
													</button>
												</div>
											</div>
										)}
									/>
								</div>
							) : (
								<div className="customer-flow-results-empty invoice-address-empty">
									Nessun indirizzo associato al cliente
								</div>
							)}
						</div>
					)}
				</div>
			</PopUp>
			{invoiceFormPopup && (
				<InvoiceFormPopup address={invoiceFormPopup} refreshAddress={refreshAddress} />
			)}
		</>
	);
}

export default InvoicePopup;
